import { Card, Flex, Spin } from "antd";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useReportEmbedUrl } from "../../../hooks/useReportEmbedUrl";
import ReportError from "./ReportError";

const ArchitecturalStatusCSVExportReport = observer(() => {

    const { reportUrl, isLoadReport, loadError } = useReportEmbedUrl("56");

    return <>
            <Flex vertical={true} gap={10}>
            <Link to="/BoardVue/Reports" style={{ marginLeft: 10 }}><ArrowLeftOutlined /> Back</Link>
                <Card>
                {/* <Card title={<Typography.Title level={5} style={{margin:0}}><b>Architectural Status CSV Export</b></Typography.Title>}> */}
                    <div></div>
                    {loadError
                        ? <ReportError message={loadError} />
                        : <iframe id="BV_ArchitecturalStatusCSVExport" className="reportIframe"
                        src={reportUrl}
                        width="100%"
                        height="1000"
                        allowTransparency={true}
                        frameBorder={0}
                    ></iframe>}
                    {isLoadReport === true && !loadError ? <>
                        <Flex gap="small" vertical>
                            <Spin/>
                        </Flex>
                    </>: <></>}
                </Card>
            </Flex>
    </>
})

export default ArchitecturalStatusCSVExportReport
